/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IHeiProductDownloadsData } from './hei-product-downloads.data';
import { IHeiProductDownloadsProps } from './hei-product-downloads.props.autogenerated';

export interface IHeiProductDownloadsViewProps extends IHeiProductDownloadsProps<IHeiProductDownloadsData> {}

/**
 *
 * HeiProductDownloads component
 * @extends {React.PureComponent<IHeiProductDownloadsProps<IHeiProductDownloadsData>>}
 */
class HeiProductDownloads extends React.PureComponent<IHeiProductDownloadsProps<IHeiProductDownloadsData>> {
    public render(): JSX.Element | null {
        const html = this.props.data.productInfo.result?.DownloadInfoHtml;
        if (!html) {
            return null;
        }

        return this.props.renderView(this.props);
    }
}

export default HeiProductDownloads;
